import React, { useMemo } from 'react';

export const Copyright = () => {
  const copyright = useMemo(() => `© ${new Date().getFullYear()}`, []);
  return <p>{copyright}</p>;
};
